export const TabSheetType = {
  Pills: 'pills',
  Tabs: 'tabs',
} as const
